import { ListingResponse } from '@/api/types';
import { User } from '@/client/users';
import { Account } from './account.type';

export type DomainVerificationToken = {
  id: string;
  name?: string | null;
  token: string;
  type: string;
  created: string;
  deleted?: string | null;
  expires?: string | null;
  payload?: unknown;
  user?: User | null;
};

export const AccountDomainStatus = {
  NON_VERIFIED: 'non-verified',
  PENDING_VERIFICATION: 'pending-verification',
  VERIFIED: 'verified',
} as const;

export type AccountDomainStatus =
  typeof AccountDomainStatus[keyof typeof AccountDomainStatus];

export type AccountDomain = {
  id: string;
  domain: string;
  status: AccountDomainStatus;
  account?: Account;
  created: string;
  updated?: string | null;
  token?: DomainVerificationToken | null;
  createdBy?: User | null;
};

export type AccountDomainsResponse = ListingResponse<AccountDomain>;

export type AddDomainRequest = {
  domain: string;
};

export type SendVerificationEmailRequest = {
  email: string;
  language?: string;
  appUrl?: string;
};
